import { createStyles, makeStyles, Theme, createTheme } from '@material-ui/core/styles';

export const TableUseStyle = makeStyles(
  createStyles({
    tableContainer: {
      maxHeight: 'calc(100vh - 210px)',
    },
    //テーブルヘッダセル
    tableHeaderCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      backgroundColor: 'grey',
      textAlign: 'center',
      color: 'white',
    },
    //テーブルボディーセル
    tableCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      textAlign: 'center',
      padding: '5px',
      minWidth: '100px',
    },
    tableRow: {
      '&.Mui-selected, &.Mui-selected:hover': {
        //背景色
        backgroundColor: '#7fffd4',
        '& > .MuiTableCell-root': {
          //文字色
          color: 'brack',
        },
      },
    },
    buttonStyle: {
      maxWidth: '180px',
      maxHeight: '35px',
      minWidth: '180px',
      minHeight: '35px',
    },
  })

);
